import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { IMAGES } from "@/data/content";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Connexion impossible.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-cream border border-forest/10 px-4 py-3 rounded-xl text-forest placeholder:text-forest/40 focus:outline-none focus:border-gold transition-colors";

  return (
    <div className="min-h-screen bg-forest flex items-center justify-center px-6">
      <div className="absolute inset-0 grain opacity-[0.04]" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <img src={IMAGES.logoLight} alt="Proxilia" className="h-10 w-auto object-contain mx-auto" />
          <p className="mt-2 font-cormorant text-xl text-cream/60">Espace administrateur</p>
        </div>
        <form onSubmit={submit} className="bg-cream rounded-[2rem] p-8 shadow-2xl" data-testid="login-form">
          <div className="w-12 h-12 rounded-2xl bg-sage/12 flex items-center justify-center mx-auto mb-6">
            <Lock className="w-5 h-5 text-sage" strokeWidth={1.5} />
          </div>
          {error && <div className="mb-5 text-sm text-red-600 bg-red-50 rounded-xl px-4 py-3" data-testid="login-error">{error}</div>}
          <div className="space-y-4">
            <input className={inputCls} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
            <input className={inputCls} type="password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <button type="submit" disabled={loading} className="group w-full mt-6 bg-forest text-cream py-3.5 rounded-full font-medium hover:bg-forestdark transition-all active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-60" data-testid="login-submit">
            {loading ? "Connexion…" : "Se connecter"}
            {!loading && <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />}
          </button>
        </form>
        <div className="text-center mt-6">
          <a href="/" className="text-cream/50 hover:text-cream text-sm transition-colors">← Retour au site</a>
        </div>
      </div>
    </div>
  );
}
